import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrderRequestsState } from './order-requests.models';

export const selectOrderRequestState = createFeatureSelector<OrderRequestsState>('orderRequests');

export const selectOrderRequest = createSelector(selectOrderRequestState, (state) => state.orderRequest);
